interface FeedToggleProps {
  activeTab: 'following' | 'foryou';
  onTabChange: (tab: 'following' | 'foryou') => void;
  showFollowing?: boolean;
}

export function FeedToggle({ activeTab, onTabChange, showFollowing = true }: FeedToggleProps) {
  const tabs = showFollowing
    ? (['following', 'foryou'] as const)
    : (['foryou'] as const);

  return (
    <div className="flex border-b border-border/50 glass sticky top-0 z-10">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`flex-1 py-3.5 text-center font-display font-semibold text-sm transition-all duration-200 relative ${
            activeTab === tab ? 'text-zinc-100' : 'text-muted hover:text-zinc-400'
          }`}
          onClick={() => onTabChange(tab)}
        >
          {tab === 'following' ? 'Following' : 'For You'}
          {activeTab === tab && (
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-14 h-0.5 bg-neon rounded-full shadow-neon-sm" />
          )}
        </button>
      ))}
    </div>
  );
}
